import { useTranslation } from "react-i18next";
import { Input, Layout } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import ManagementTableList from "./ManagementTableList";
import { routesConfig } from "../../../config/routes";
import PageHeaderCommon from "../../../components/page-header-common/PageHeaderCommon";
import { useState } from "react";
import { SearchProps } from "antd/es/input";
const imgPath = "/images/";

const { Content } = Layout;
const { Search } = Input;

const SearchFilter = ({onSearch}: any) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState<string>("");
  const handleChangeSearch = (e: any) => {
    setSearchText(e?.target?.value);
  };
  return (
    <div className="heading-search">
      <Search
        placeholder={t("Nhập tên hoặc mã bảng điểm cần tìm", "Nhập tên hoặc mã bảng điểm cần tìm")}
        onSearch={onSearch}
        value={searchText}
        onChange={handleChangeSearch}
      />
    </div>
  );
};

const ManagementListScore = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const params = useParams();
  const [searchValue, setSearchValue] = useState<string>("");

  const listBreadcrumb = [
    {
      title: t("Cài đặt nâng cao", "Cài đặt nâng cao"),
    },
    {
      title: t("Quản lý chấm điểm tự động", "Quản lý chấm điểm tự động"),
    },
    {
      title: t("Bài thi 01", "Bài thi 01"),
    },
    {
      title: t("Quản lý bảng điểm", "Quản lý bảng điểm"),
    },
  ];

  const onSearch: SearchProps["onSearch"] = (value, _e, info) => {
    setSearchValue(value);
  };
  return (
    <Content>
      <PageHeaderCommon
        listBreadcrumb={listBreadcrumb}
        title={t("Quản lý bảng điểm", "Quản lý bảng điểm")}
        arrowLeft={imgPath + "arrowLeft.svg"}
        positionItem="column"
        breadcrumb={true}
        handleBack={() => navigate(-1)}
        headerGroupButton
        childrenGroupButton={<SearchFilter onSearch={onSearch} />}
      />
      <ManagementTableList searchValue={searchValue} />
    </Content>
  );
};

export default ManagementListScore;
